export default {
  disabledIntegration: {
    cursor: "not-allowed"
  },
  enabledIntegration: {
    // EMPTY
  },
  integrationList: {
    background: "#EEE",
    boxShadow: "inset -1px 0 8px rgba(0, 0, 0, 0.15)",
    paddingRight: "2em"
  },
  informations: {
    display: "inline-flex",
    alignItems: "center",
    marginTop: "10px"
  },
  enabledIconTrue: {
    padding: "2px 0px 0px",
    color: "green"
  },
  enabledIconFalse: {
    padding: "2px 0px 0px",
    color: "red"
  },
  message: {
    paddingLeft: "6px",
    fontWeight: "bolder",
    fontSize: "17px"
  }
};



// WEBPACK FOOTER //
// ./src/components/app/registration/company/view/integrations/styles.js